import * as React from "react";
import { useEffect, useState } from "react";
import {
    Autocomplete,
    Box,
    Button,
    Divider,
    Stack,
    TextField,
    Typography,
    Grid,
    Card,
    Paper,
    CircularProgress
} from "@mui/material";
import { DataGrid, GridColDef } from "@mui/x-data-grid";
import { useFormik } from "formik";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import ToastApp from "../../ToastApp";
import * as XLSX from "xlsx";
import api from "../../utils/Url";
import ArrowBackSharpIcon from "@mui/icons-material/ArrowBackSharp";
import { useNavigate } from "react-router-dom";
import Logo from "../../assets/images/CSJMUlog.png";
import Watermark from "../../assets/images/CSJMUlogo.png";

export default function QueryType() {
    const { t } = useTranslation();
    const [quertOpt, setQuertOpt] = useState([]);
    const [data, setData] = useState<any[]>([]);
    const [columns, setColumns] = useState<GridColDef[]>([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        getQueryData();
    }, []);

    const getQueryData = () => {
        const collectData = { id: -1 };
        api.post(`Query/GetQuery`, collectData).then((response) => {
            const data = response.data.data;
            const resp = data.map((item: any) => ({
                value: item?.id,
                label: item?.queryType,
                queryDetail: item?.queryDetail,
            }));
            setQuertOpt(resp);
        });
    };

    const GetExcuteQuery = () => {
        setLoading(true);
        const collectData = { queryid: formik.values.id };
        api.post(`Query/GetExcuteQuery`, collectData).then((response) => {
            const responseData = response.data.data;
            setData(responseData);

            if (responseData.length > 0) {
                const extractedColumns: GridColDef[] = Object.keys(responseData[0]).map((key) => ({
                    field: key,
                    headerName: key.toUpperCase(),
                    flex: 1,
                    minWidth: 200,
                }));
                setColumns(extractedColumns);
            }

            setLoading(false);
        });
    };

    const downloadExcel = () => {
        if (!data || data.length === 0) {
            toast.error("No data to export!");
            return;
        }
        const ws = XLSX.utils.json_to_sheet(data);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "QueryData");
        XLSX.writeFile(wb, `${formik.values.queryType}_data.xlsx`);
    };

    // const downloadPdf = () => {
    //     if (!data || data.length === 0) {
    //         toast.error("No data to print!");
    //         return;
    //     }

    //     const printWindow = window.open("", "_blank");
    //     const content = `
    //         <html>
    //             <head>
    //                 <title>Print Report - CSJMU Library</title>
    //                 <style>
    //                     body {
    //                         font-family: Arial, sans-serif;
    //                         margin: 20px;
    //                         position: relative;
    //                     }
    //                     /* Header Section */
    //                     .header {
    //                         display: flex;
    //                         align-items: center;
    //                         justify-content: center;
    //                         border-bottom: 3px solid #0d3b5c;
    //                         padding: 30px 0;
    //                         margin-bottom: 30px;
    //                         position: relative;
    //                     }
    //                     .logo {
    //                         width: 100px;
    //                         height: auto;
    //                         position: absolute;
    //                         left: 20px;
    //                         top: 50%;
    //                         transform: translateY(-50%);
    //                     }
    //                     .title {
    //                         font-size: 24px;
    //                         font-weight: bold;
    //                         color: #0d3b5c;
    //                         text-transform: uppercase;
    //                         text-align: center;
    //                     }
    //                     h2 {
    //                         text-align: center;
    //                         margin-bottom: 20px;
    //                         color: #0d3b5c;
    //                     }
    //                     /* Table Styling */
    //                     table {
    //                         width: 100%;
    //                         border-collapse: collapse;
    //                         margin-top: 10px;
    //                         position: relative;
    //                         z-index: 2;
    //                     }
    //                     th, td {
    //                         border: 1px solid black;
    //                         padding: 12px;
    //                         text-align: left;
    //                     }
    //                     th {
    //                         background-color: #0d3b5c;
    //                         color: white;
    //                         text-align: center;
    //                     }
    //                     td:nth-child(1) { width: 45%; }
    //                     td:nth-child(2) { width: 35%; }
    //                     td:nth-child(3) { width: 20%; text-align: center; }
    //                     /* Watermark Styling */
    //                     .watermark {
    //                         position: fixed;
    //                         top: 50%;
    //                         left: 50%;
    //                         transform: translate(-50%, -50%);
    //                         width: 50%;
    //                         height: auto;
    //                         z-index: 1;
    //                         opacity: 0.8;
    //                     }
    //                 </style>
    //             </head>
    //             <body>
    //                 <!-- Header Section -->
    //                 <div class="header">
    //                     <img class="logo" src="${Logo}" alt="CSJMU Logo" id="logo">
    //                     <div class="title">CSJMU LIBRARY KANPUR</div>
    //                 </div>

    //                 <!-- Watermark Image -->
    //                 <img class="watermark" src="${Watermark}" alt="Watermark Logo" id="watermark">

    //                 <!-- Table Section -->
    //                 <table>
    //                     <thead>
    //                         <tr>
    //                             <th>Title</th>
    //                             <th>Author</th>
    //                             <th>Copy</th>
    //                         </tr>
    //                     </thead>
    //                     <tbody>
    //                         ${(data || [])
    //             .map(
    //                 (row) => `
    //                                 <tr>
    //                                     <td>${row.Title}</td>
    //                                     <td>${row.Author || ""}</td>
    //                                     <td>${row.Copy || ""}</td>
    //                                 </tr>
    //                             `
    //             )
    //             .join("")}
    //                     </tbody>
    //                 </table>

    //                 <script>
    //                     function waitForImages() {
    //                         const images = document.querySelectorAll("img");
    //                         let loadedCount = 0;

    //                         images.forEach(img => {
    //                             if (img.complete) {
    //                                 loadedCount++;
    //                             } else {
    //                                 img.onload = () => {
    //                                     loadedCount++;
    //                                     if (loadedCount === images.length) {
    //                                         window.print();
    //                                     }
    //                                 };
    //                                 img.onerror = () => {
    //                                     loadedCount++;
    //                                     if (loadedCount === images.length) {
    //                                         window.print();
    //                                     }
    //                                 };
    //                             }
    //                         });

    //                         if (loadedCount === images.length) {
    //                             window.print();
    //                         }
    //                     }

    //                     waitForImages();
    //                 </script>
    //             </body>
    //         </html>
    //     `;

    //     if (printWindow) {
    //         setTimeout(() => {
    //             printWindow.document.write(content);
    //             printWindow.document.close();
    //         }, 1000);
    //     } else {
    //         console.error("Failed to open print window.");
    //     }
    // };


    const downloadPdf = () => {
        if (!data || data.length === 0) {
            toast.error("No data to print!");
            return;
        }

        const printWindow = window.open("", "_blank");
        const content = `
            <html>
                <head>
                    <title>Print Report - CSJMU Library</title>
                    <style>
                        body {
                            font-family: Arial, sans-serif;
                            margin: 20px;
                            position: relative;
                        }
                        /* Header Section */
                        .header {
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            border-bottom: 3px solid #0d3b5c;
                            padding: 30px 0;
                            margin-bottom: 30px;
                            position: relative;
                        }
                        .logo {
                            width: 100px;
                            height: auto;
                            position: absolute;
                            left: 20px;
                            top: 50%;
                            transform: translateY(-50%);
                        }
                        .title {
                            font-size: 24px;
                            font-weight: bold;
                            color: #0d3b5c;
                            text-transform: uppercase;
                            text-align: center;
                        }
                        h2 {
                            text-align: center;
                            margin-bottom: 20px;
                            color: #0d3b5c;
                        }
                        h3 {
                            text-align: center;
                            color: #0d3b5c;
                            margin-bottom: 20px;
                        }
                        /* Table Styling */
                        table {
                            width: 100%;
                            border-collapse: collapse;
                            margin-top: 10px;
                            position: relative;
                            z-index: 2;
                        }
                        th, td {
                            border: 1px solid black;
                            padding: 12px;
                            text-align: left;
                        }
                        th {
                            background-color: #0d3b5c;
                            color: white;
                            text-align: center;
                        }
                        td:nth-child(1) { width: 45%; }
                        td:nth-child(2) { width: 35%; }
                        td:nth-child(3) { width: 20%; text-align: center; }
                        /* Watermark Styling */
                        .watermark {
                            position: fixed;
                            top: 50%;
                            left: 50%;
                            transform: translate(-50%, -50%);
                            width: 50%;
                            height: auto;
                            z-index: 1;
                            opacity: 0.8;
                        }
                    </style>
                </head>
                <body>
                    <!-- Header Section -->
                    <div class="header">
                        <img class="logo" src="${Logo}" alt="CSJMU Logo" id="logo">
                        <div class="title">CSJMU LIBRARY KANPUR</div>
                    </div>
    
                    <!-- Watermark Image -->
                    <img class="watermark" src="${Watermark}" alt="Watermark Logo" id="watermark">
    
                    <!-- Dynamic Query Type Heading -->
                    <h3>${formik.values.queryType}</h3>
    
                    <!-- Table Section -->
                    <table>
                        <thead>
                            <tr>
                                <th>Title</th>
                                <th>Author</th>
                                <th>Copy</th>
                            </tr>
                        </thead>
                        <tbody>
                            ${(data || [])
                .map(
                    (row) => `
                                    <tr>
                                        <td>${row.Title}</td>
                                        <td>${row.Author || ""}</td>
                                        <td>${row.Copy || ""}</td>
                                    </tr>
                                `
                )
                .join("")}
                        </tbody>
                    </table>
    
                    <script>
                        function waitForImages() {
                            const images = document.querySelectorAll("img");
                            let loadedCount = 0;
    
                            images.forEach(img => {
                                if (img.complete) {
                                    loadedCount++;
                                } else {
                                    img.onload = () => {
                                        loadedCount++;
                                        if (loadedCount === images.length) {
                                            window.print();
                                        }
                                    };
                                    img.onerror = () => {
                                        loadedCount++;
                                        if (loadedCount === images.length) {
                                            window.print();
                                        }
                                    };
                                }
                            });
    
                            if (loadedCount === images.length) {
                                window.print();
                            }
                        }
    
                        waitForImages();
                    </script>
                </body>
            </html>
        `;

        if (printWindow) {
            setTimeout(() => {
                printWindow.document.write(content);
                printWindow.document.close();
            }, 1000);
        } else {
            console.error("Failed to open print window.");
        }
    };


    const formik = useFormik({
        initialValues: {
            id: -1,
            queryType: "",
            queryDetail: "",
        },
        onSubmit: async (values: any) => { },
    });

    const back = useNavigate();

    return (
        <Grid item lg={12} sm={12} xs={12} sx={{ marginTop: "3vh" }}>
            <Card
                style={{
                    width: "100%",
                    backgroundColor: "#E9FDEE",
                    border: ".5px solid #FF7722",
                    padding: "10px",
                }}
            >
                <Paper
                    sx={{
                        width: "100%",
                        overflow: "hidden",
                        "& .MuiDataGrid-colCell": {
                            backgroundColor: "#2B4593",
                            color: "#fff",
                            fontSize: 18,
                            fontWeight: 800,
                        },
                    }}
                    style={{ padding: "10px" }}
                >


                    <Button
                        type="submit"
                        onClick={() => back(-1)}
                        variant="contained"
                        style={{
                            backgroundColor: "#00009c",
                            width: 20,
                        }}
                    >
                        <ArrowBackSharpIcon />
                    </Button>


                    <Typography variant="h5" sx={{ padding: "20px" }}>
                        {t("text.QueryType")}
                    </Typography>
                    <Divider />

                    <Stack spacing={2} mt={2}>
                        <form onSubmit={formik.handleSubmit}>
                            <Grid container spacing={2}>
                                <Grid item xs={12} sm={7}>
                                    <Autocomplete
                                        disablePortal
                                        options={quertOpt}
                                        fullWidth
                                        size="small"
                                        onChange={(event, newValue: any) => {
                                            formik.setFieldValue("id", newValue?.value);
                                            formik.setFieldValue("queryType", newValue?.label);
                                            formik.setFieldValue("queryDetail", newValue?.queryDetail);
                                        }}
                                        renderInput={(params) => (
                                            <TextField {...params} label={t("text.Selectquerytype")} />
                                        )}
                                    />
                                </Grid>

                                <Grid item xs={12} sm={5} display="flex" justifyContent="center">
                                    <Button
                                        variant="contained"
                                        size="small"
                                        onClick={(e) => {
                                            e.preventDefault();
                                            GetExcuteQuery();
                                        }}
                                    >
                                        {loading ? <CircularProgress size={24} style={{ color: "white" }} /> : "Execute"}
                                    </Button>

                                    <Button
                                        variant="contained"
                                        size="small"
                                        onClick={(e) => {
                                            e.preventDefault();
                                            downloadExcel();
                                        }}
                                        sx={{ ml: 1 }}
                                    >
                                        Download Excel
                                    </Button>
                                    <Button
                                        variant="contained"
                                        size="small"
                                        onClick={(e) => {
                                            e.preventDefault();
                                            downloadPdf();
                                        }}
                                        sx={{ ml: 1 }}
                                    >
                                        Download Pdf
                                    </Button>
                                </Grid>

                                <Grid item xs={12}>
                                    <Box
                                        sx={{
                                            padding: "10px",
                                            backgroundColor: "#f5f5f5",
                                            borderRadius: "5px",
                                            minHeight: "50px",
                                            border: "1px solid #ccc",
                                        }}
                                    >
                                        {formik.values.queryDetail || "No query Selected"}
                                    </Box>
                                </Grid>

                                <Grid item xs={12}>
                                    <DataGrid
                                        rows={data.map((row, index) => ({ id: index, ...row }))}
                                        columns={columns}
                                        pageSizeOptions={[5, 10, 20, 50]}
                                        initialState={{
                                            pagination: {
                                                paginationModel: { pageSize: 5, page: 0 },
                                            },
                                        }}
                                        autoHeight
                                        disableRowSelectionOnClick
                                        sx={{
                                            "& .MuiDataGrid-columnHeaders": {
                                                backgroundColor: "#2B4593",
                                                color: "white",
                                                fontSize: "16px",
                                                fontWeight: "bold",
                                            },
                                        }}
                                    />

                                </Grid>
                            </Grid>
                        </form>
                    </Stack>
                </Paper>
            </Card>
            <ToastApp />
        </Grid>
    );
}
